import { render, staticRenderFns } from "./CalendarIndex.vue?vue&type=template&id=534b7822&"
import script from "./CalendarIndex.vue?vue&type=script&lang=js&"
export * from "./CalendarIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports